module.exports = __webpack_public_path__ + "static/media/homesIcon.4b7cbf09.png";